import { render, staticRenderFns } from "./c_upload_video.vue?vue&type=template&id=017b1256&scoped=true"
import script from "./c_upload_video.vue?vue&type=script&lang=js"
export * from "./c_upload_video.vue?vue&type=script&lang=js"
import style0 from "./c_upload_video.vue?vue&type=style&index=0&id=017b1256&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017b1256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017b1256')) {
      api.createRecord('017b1256', component.options)
    } else {
      api.reload('017b1256', component.options)
    }
    module.hot.accept("./c_upload_video.vue?vue&type=template&id=017b1256&scoped=true", function () {
      api.rerender('017b1256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_upload_video.vue"
export default component.exports